import liff from "@line/liff";
import { GRAB_WEB_ORIGIN_URL, LINE_LIFF_OPT_OUT } from "@configs";
import * as Sentry from "@sentry/react";
import loading from "@assets/gif/loading.gif";

export const CallBackPage = () => {
  const getProfile = () => {
    liff
      .getProfile()
      .then(async (profile) => {
        const lang = await liff.getLanguage();
        let language = "en";
        if (lang === "th-TH") language = "th";

        const userId = profile.userId;
        window.location.replace(
          `${GRAB_WEB_ORIGIN_URL}/mex-auth/deauth?line_user_id=${userId}&lang=${language}`
        );
      })
      .catch((e) => {
        Sentry.captureException(e);
      });
  };

  liff
    .init({
      liffId: LINE_LIFF_OPT_OUT,
    })
    .then(() => {
      getProfile();
    })
    .catch(() => liff.closeWindow());

  return (
    <div className="min-h-screen flex content-center items-center justify-center">
      <img src={loading} alt="loading" />
    </div>
  );
};
